// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/login/bg-owner-login.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../images/login/customer-login-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-section {
  /* background-image: url(../images/feature-bg.png); */
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 1080px;
  background-color: #fff;
  position: relative;
}

.banner-section .pattern {
  position: absolute;
  width: 50%;
  /* background: url(../images/pattern-img.png) no-repeat right; */
  height: 88px;
  left: 0;
  bottom: 0;
}

.banner-section .banner-img {
  right: 0;
  top: 0;
  object-fit: cover;
  height: 1080px;
  width: 50%;
}

.banner-section .caption {
  max-width: 100%;
  color: #e7e1d8;
  padding-left: 160px !important;
  margin-top: 10rem;
}

.banner-section .caption h1 {
  color: var(--Black, #010404);
  line-height: normal;
  letter-spacing: 3.2px;
  text-transform: capitalize;
}

.banner-section .caption h1 span {
  color: #163873;
}

.banner-section .caption h5 {
  color: #808282;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 4px;
  text-transform: uppercase;
}

.banner-section .caption p {
  margin-bottom: 10px;
  color: var(--Black, #010404);
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  text-align: left;
}

.line {
  border-radius: 4px;
  background: var(--Primary, #163873);
  width: 70px;
  height: 3px;
}

.banner-section .caption .btn.btn-default {
  margin-top: 31px;
}

.guest_serch_block {
  border-radius: 20px;
  padding: 30px;
  gap: 30px;
  width: 100%;
  min-height: 190px;
  position: absolute;
  left: 50%;
  bottom: 35%;
  transform: translate(-50%, 100%);
  z-index: 1;
}

.guest_serch_block .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--Primary, #549cac);
  background-color: transparent;
}

.guest_serch_block .nav-link {
  color: var(--Gray-1, #808282);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: 0.6s all ease-in-out;
}

.content_tab {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 50px;
}

/* .items_tab {
    max-width: 250px;
    width: 100%;
    position: relative;
    border-right: 1px solid #E9ECEF;
}
.items_tab:nth-child(4){
	border: none;
} */

.items_tab h4 {
  color: #231f20;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 10px;
}

.items_tab p {
  color: #010404;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.items_tab .form-control {
  color: var(--Gray-1, #808282);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  border: none;
  padding-left: 35px;
}

.items_tab i {
  position: absolute;
  bottom: 10px;
  left: 10px;
  color: #5c677d;
}

.items_search a {
  display: flex;
  width: 60px;
  height: 60px;
  justify-content: center;
  align-items: center;
  gap: 20px;
  border-radius: 12px;
  background: var(--Primary, #163873);
}

.items_search a i {
  color: #fff;
  font-size: 34px;
}

/*Why US Section*/
.why_us_wrap h2 {
  text-align: center;
  margin-bottom: 50px;
  color: var(--Black, #010404);

  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1.8px;
  text-transform: capitalize;
}

.why_us_wrap h2 span {
  color: #163873;
}

.card_us {
  display: flex;
  align-items: center;
  gap: 25px;
  border-radius: 14px;
  border: 1px solid var(--Stroke, #e9ecef);
  background: #fff;
  padding: 20px;
  min-height: 100%;
  overflow: auto;
  flex-direction: row !important;
}

.icon_sec {
  min-width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon_sec.card_one {
  border-radius: 12px;
}

.icon_sec.card_two {
  border-radius: 12px;
  background: rgba(157, 78, 221, 0.1);
}

.icon_sec.card_three {
  border-radius: 12px;
  background: rgba(0, 124, 255, 0.1);
}

.icon_sec.card_four {
  border-radius: 12px;
  background: rgba(0, 128, 0, 0.1);
}

.card.card_us p {
  color: #000000;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
}

/*Quality Listings Section*/
.quality_content h2 {
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: capitalize;
  margin-bottom: 20px;
}

.btn_sec {
  display: flex;
  gap: 15px;
}

.btn_sec .btn {
  width: 180px;
  height: 50px;
}

.btn_sec .btn:hover {
  border: none;
  background-color: #000;
  color: #fff;
}

.quality_pic {
  margin-bottom: 50px;
  position: relative;
  transition: 0.6s all ease-in-out;
}

.quality_pic img {
  width: 100%;
}

.quality_caption {
  position: absolute;
  bottom: 0px;
  left: 15px;
}

.quality_caption h5 {
  color: var(--White, #fff);
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.quality_caption p {
  color: var(--White, #fff);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

/*Home for you*/
.home_heading p {
  color: var(--Gray, #5c677d);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: capitalize;
  text-align: center;
  margin-top: 10px;
}

.image_body .slick-dots {
  bottom: 20px;
}

.image_body .slick-dots li button:before {
  font-size: 10px;
  line-height: 20px;
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  content: "•";
  text-align: center;
  opacity: 0.5;
  color: #eeeeee;
}

.image_body {
  margin-bottom: 0 !important;
}

.image_body .slick-dots li.slick-active button:before {
  color: #fff;
  opacity: 1;
}

.home_card {
  border-radius: 20px !important;
  box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.03);
}

.badge_btn {
  width: 61px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 10px;
  border-radius: 30px;
  background: #1638731a;
}

.badge_btn p {
  color: var(--Primary, #163873);
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 0;
}

.card_heading_block {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card_heading_block h2 {
  color: #000;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: normal;
  text-transform: capitalize;
}

.card_heading_block span {
  color: #000;

  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.card_location {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  gap: 15px;
  border-bottom: 1px solid #e9ecef;
}

.card_desc {
  padding-top: 10px;
}

.card_desc p {
  color: var(--Gray, #5c677d);
  text-align: justify;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.card_bottom_icon {
  display: flex;
  gap: 10px;
}

.card_btn {
  width: 100%;
}

.card_btn .btn_primary {
  width: 100%;
  border-radius: 0px 0px 20px 20px;
  height: 50px;
}

.image_header {
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  padding: 10px;
  align-items: center;
}

.image_header_booking {
  position: absolute;
  top: 20px;
  left: 0;
  width: 100%;
  padding: 10px;
  align-items: center;
}

.quantity_box {
  width: 100%;
  max-width: 106px;
  border-radius: 6px;
  background: #fff;
  padding: 5px;
  height: 30px;
}

.box-quant {
  display: flex;
  align-items: center;
  gap: 5px;
}

.btn_view {
  max-width: 180px;
  width: 100%;
  height: 50px;
}

/* 5.Contact Us*/
.contact_content {
  max-width: 1000px;
  margin: auto;
}

.or_seprate {
  max-width: 350px;
  width: 100%;
  height: 1px;
  background: #5c677d1f;
  margin: auto;
  text-align: center;
  position: relative;
}

.or_seprate span {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -55%);
  background: #fff;
  padding: 5px;
  color: var(--Gray, #5c677d);

  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.contact_block {
  width: 100%;
  align-items: center;
}

.contact_desc h4 {
  color: var(--Gray, #5c677d);

  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: capitalize;
}

.contact_desc p {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.2px;
}

.contact_desc p a {
  color: #163873;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.2px;
  text-decoration-line: underline;
  white-space: nowrap;
}

.form-field-input {
  height: 50px;
  color: #808282 !important;
}

.h2-tag-text {
  font-size: 36px;
  font-weight: 700;
  line-height: 43px;
  letter-spacing: 0em;
  color: #010404;
}

/*Banner properties Page*/
.inner_banner {
  width: 100%;
  margin-top: 124px;
}

.inner_banner img {
  width: 100%;
}

.banner_search_box {
  border-radius: 20px;
  background: #fff;
  box-shadow: 0px 0px 40px 0px rgba(84, 156, 172, 0.2);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  padding: 30px;
  width: 100%;
  max-width: 1470px;
  min-height: 190px;
  position: relative;
  bottom: 95px;
  z-index: 1;
}

.banner_search_box .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--Primary, #163873);
  background-color: transparent;
}

.banner_search_box .nav-link {
  color: var(--Gray-1, #808282);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: 0.6s all ease-in-out;
}

/*Banner Search box*/
.properties_search_sec,
.tab_top_btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.btn_clear {
  display: flex !important;
  height: 40px !important;
  padding: 0px 12px !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 10px !important;
  border-radius: 8px !important;
  background: rgba(253, 13, 13, 0.1) !important;
  color: #fd0d0d !important;
  text-align: center !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal !important;
}

.banner_search_box .content_tab {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 50px;
}

.tab_range h4 {
  color: var(--Dark, #231f20);
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 10px;
  margin-top: 20px;
}

.value-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--Dark, #231f20);
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.values {
  padding: 20px 0;
  display: flex;
  color: var(--Dark, #231f20);
  text-align: center;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.max-value {
  margin-left: auto;
}

.range-slider {
  margin-top: 10px;
  position: relative;
}

.range-slider-track {
  width: 100%;
  height: 10px;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  background: var(--Stroke, #e9ecef);
}

.slider-track-filled {
  width: 100%;
  height: 10px;
  position: absolute;
  transform-origin: 0 0;
  border-radius: 10px;
  background: var(--Primary, #163873);
}

.min-thumb,
.max-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 4;
  -webkit-user-select: none;
          user-select: none;
  filter: drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.18));
}

.min-thumb {
  left: 0;
}

.max-thumb {
  right: 0;
}

/*Filter Section*/
.filter_block {
  border-right: 1px solid #e9ecef;
}

.filter_side {
  width: 100%;
  min-width: 314px !important;
}

.filter_side_content h5 {
  color: var(--Black, #010404);
  text-align: justify;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 20px;
}

.side_items label {
  color: var(--Black, #000);
  text-align: justify;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.side_items .form-check-input:checked {
  background-color: #163873;
  border-color: #163873;
}

.side_items {
  margin-bottom: 15px;
}

.filter_side_content .input-group {
  margin-bottom: 15px;
}

/* lg-8 */
.filter_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.filter_header_btns {
  display: flex;
  align-items: center;
  gap: 10px;
}

.sort_drop {
  display: flex;
  align-items: center;
  min-width: 200px;
  width: 100%;
  gap: 10px;
}

.filter_header h5 {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}

.sort_drop label {
  color: var(--Black, #010404);
  min-width: 50px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.filter_content .home_card {
  flex-direction: row;
  padding: 10px;
  align-items: center;
}

.filter_content .image_body {
  max-width: 300px;
  width: 100%;
  height: 100%;
}

.filter_content .card-body {
  width: 100%;
}

.filter_content .card_btn {
  width: auto;
}

.filter_content .btn_primary {
  border-radius: 10px;
}

.filter_content .pic_item img {
  border-radius: 20px !important;
}

.filter_pagination {
  display: flex;
  justify-content: end;
  align-items: center;
}

.filter_pagination .page-link {
  color: var(--Gray, #5c677d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border: none;
}

.filter_pagination .active > .page-link,
.page-link.active {
  border-radius: 10px;
  background: var(--Primary, #163873);
  color: var(--White, #fff);
}

.filter_content .slick-next:before,
.slick-prev:before {
  display: none;
}

/* (Page 3:) 1: Detail Banner Page*/
.detail_banner {
  width: 100%;
  margin-top: 124px;
}

.bg-detail {
  width: 100%;
  height: 100%;
}

.detail_banner img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.side_detail_pic {
  width: 100%;
  min-height: 150px;
}

.side_detail_pic img {
  border-radius: 20px;
  width: 100%;
  object-fit: cover;
  min-height: 150px;
}

.star {
  width: auto !important;
}

/* (Page 3:)  Booking Section*/
.booking_larg .badge_btn {
  width: 85px;
  height: 35px;
  border-radius: 40px;
  margin-bottom: 10px;
}

.booking_larg .badge_btn p {
  color: var(--Primary, #163873);
  font-size: 14px;
}

.booking_larg .card_heading_block h2 {
  color: #000;
  font-size: 32px !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: capitalize;
}

.booking_larg .card_location {
  margin-top: 10px;
}

.booking_larg .card_location p {
  color: var(--Primary, #163873);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.booking_larg .card_desc {
  margin-top: 10px;
}

.booking_larg .card_desc h4 {
  color: var(--Black, #010404);
  text-align: justify;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 15px;
}

.booking_larg .card_desc p {
  color: var(--Gray, #5c677d);
}

.feature_icon_sec {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.features_bedroom {
  border-bottom: 1px solid #e9ecef;
}

.feature_icon {
  display: flex;
  gap: 15px;
  align-items: center;
}

.available_block {
  display: flex;
  align-items: end;
  gap: 10px;
}

.availability_calender img {
  width: 100%;
}

.map_tour {
  border-top: 1px solid #e9ecef;
}

.map_btn_sec .btn_primary {
  width: 100%;
}

/* booking card */
.booking_card {
  border-radius: 20px !important;
  background: #fff;
  box-shadow: 0px 0px 40px 0px rgba(84, 156, 172, 0.2);
  border: #ffffff !important;
  padding: 30px;
}

.booking_dollar p {
  color: #000;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.booking_dollar p span {
  color: var(--Gray, #5c677d);
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.booking_card_content .input_group {
  width: 48%;
}

.booking_card_content .input_group .form-select {
  border: none;
  color: var(--Black, #010404);
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  padding: 0px;
  background-image: none;
}

.agent_code p {
  color: var(--Gray, #5c677d);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.agent_code p span {
  color: var(--Gray, #5c677d);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.agent_code h3 {
  color: var(--Primary, #163873);
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
}

.input_group label {
  color: var(--Gray, #5c677d);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.input_group h6 {
  color: var(--Black, #010404);
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  margin-top: 10px;
}

.border-_bottom {
  border-bottom: 1px solid #e9ecef;
}

.total label {
  color: var(--Black, #010404);
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.reserve .btn_primary {
  width: 100%;
  height: 50px;
  font-size: 20px !important;
}

/* (Page 4:) My Booking Section*/
.btn_chat {
  display: flex;
  width: 200px;
  height: 50px;
  padding: 2px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid var(--Primary, #163873);
  background: var(--White, #fff);
  color: var(--Primary, #163873);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.border-_top {
  border-top: 1px solid #e9ecef;
}

.listing_booking {
  margin-top: 125px;
}

.btn_pending {
  width: 150px;
  height: 50px;
  border-radius: 10px;
  background: #ffd9c4;
  color: #ff8038;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.btn_accepted {
  width: 150px;
  height: 50px;
  border-radius: 10px;
  background: rgba(56, 176, 0, 0.3);
  color: #38b000;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.online_condiiton {
  display: flex;
  align-items: center;
  gap: 50px;
  justify-content: space-between;
}

/*--------------------------------------*/

/* (Page 5:) Chat Page
/*--------------------------------------*/

.chat_sec {
  margin-top: 124px;
}

.side_agent {
  margin: 30px 0px;
  border-radius: 20px;
  background: #fff;
  padding: 0px 10px;
  min-height: 100%;
  height: 100vh !important;
}

.user_side_agent {
  min-height: 94% !important;
}
.agent_search {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  gap: 15px;
  height: 50px;
  border-bottom: 1px solid #e5e6e7;
  padding: 40px 0px;
}

.btn_agent {
  background: #eef5f7;
  padding: 10px 12px;
}

.agent_category .btn_primary {
  height: 35px;
  width: 100%;
  color: var(--Gray-1, #808282);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  background-color: transparent;
  justify-content: left;
  padding: 10px 5px;
}

.agent_category {
  display: flex;
  align-items: center;
  gap: 15px;
}

.agent_category .dropdown {
  width: 100%;
}

.agent_category .dropdown-menu.show {
  display: block;
  width: 100%;
}

.agent_item_list {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 10px;
  cursor: pointer;
}

.active_agent {
  border-radius: 12px;
  background: rgba(129, 217, 247, 0.25);
}

.agent_name {
  display: flex;
  align-items: center;
  gap: 15px;
}

.agent_name h5 {
  color: var(--Black, #010404);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.agent_name p {
  color: var(--Gray-1, #808282);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.agent_mode p {
  margin: 0;
  color: var(--Gray-1, #808282);
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.agent_chatbot {
  margin: 30px 0px;
}

.chat_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 20px;
  background: var(--grayscale-white, #fff);
  padding: 20px;
  gap: 10px;
}

.agent_logo {
  display: flex;
  align-items: center;
  gap: 15px;
}

.chat_agent h5 {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.chat_agent p {
  color: var(--Gray-1, #808282);
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
}

.chat_bedroom h3 {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.chat_bedroom p {
  color: var(--Gray-1, #808282);
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 5px;
}

.chat_bedroom p a {
  color: #163873;
}

/* ------------ */

.chat-online {
  color: #34ce57;
}

.chat-offline {
  color: #e4606d;
}

.chat-messages {
  display: flex;
  flex-direction: column;
}

.chat-message-right {
  display: block;
  margin-left: auto;
}

.chat-message-left {
  margin-right: auto;
  display: flex;
  flex-shrink: 0;
}

.chat-messages .py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.chat-messages .px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.chat-messages .flex-grow-0 {
  flex-grow: 0 !important;
}

.chat-messages .border-top {
  border-top: 1px solid #dee2e6 !important;
}

.Amelia_text h3 {
  color: var(--Black, #010404);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.Amelia_text p {
  color: var(--Black, #010404);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 0px 12px 12px 12px;
  background: var(--White-color, #fff);
  padding: 10px;
  margin: 0;
}

.cht_time .text-muted {
  color: #808282 !important;
  font-size: 8px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 15px;
}

.you_right {
  display: flex;
  gap: 10px;
  justify-content: end;
}

.right_text .text-muted {
  color: var(--Gray-1, #808282) !important;
  font-size: 8px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.you_right h3 {
  color: var(--Black, #010404);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.right_msg {
  display: flex;
  width: 100%;
  text-align: justify;
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border-radius: 12px 0px 12px 12px;
  background: #163873;
  margin-top: 5px;
}

.chat_footer img {
  position: absolute;
  right: 10px;
  top: 10px;
}

.chat_footer .form-control {
  border: none;
  border-radius: 10px;
  background: var(--White-color, #fff);
  padding: 15px;
  color: #808282 !important;
  font-size: 12px;
  font-weight: 400;
}

.chat_profile {
  margin: 30px 0px;
  height: 100%;
}

.profile_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 20px;
  border: 1px solid var(--Stroke, #e9ecef);
  background: #fff;
  padding: 15px;
}

.booked_date label {
  color: var(--Gray, #5c677d);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.booked_date h3 {
  color: var(--Black, #010404);
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
}

.profile_content {
  border-radius: 14px;
  background: var(--White-color, #fff);
  padding: 50px 15px 0px;
  margin: 20px 0px;
  min-height: 100%;
  height: 100vh;
}

.user_profile_content {
  min-height: 83% !important;
}
.dp_pic {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.dp_pic h3 {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.dp_pic p {
  color: var(--Gray-1, #808282);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0;
}

button.nav-link.active {
  color: #163873 !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 19px !important;
  letter-spacing: 0px !important;
}

.form-check-input:checked {
  background-color: #163873 !important;
  border-color: #163873 !important;
}

.classUnique {
  font-weight: 700 !important;
  padding-right: 5px;
  padding-left: 5px;
}

.quality_img {
  width: 200px !important;
  height: 200px;
  border-radius: 30px;
}

/* Seema-code */
.h4-feature {
  font-size: 24px;
  font-weight: 700;
  text-align: justify;
  color: #010404;
}

.small_feature {
  font-size: 14px;
  font-weight: 600;
  color: #010404;
}

.btn-booking-tour {
  height: 50px;
  font-size: 20px !important;
}

.send {
  font-size: 18px;
  font-weight: 700;
  color: #010404;
}

.contact-feature {
  font-size: 36px;
  font-weight: 700;
}

.homeforyou {
  font-size: 36px !important;
  font-weight: 700 !important;
  color: #010404;
}

.bannertext {
  font-weight: 900 !important;
  font-size: 64px;
}

/* Bhupendra new css */
.img-carousel {
  max-width: 300px;
  min-height: 210px;
}

.span-tag-card {
  font-size: 14px;
  font-weight: 400;
  color: #010404;
}

.btn-more-info {
  min-width: 150px !important;
  min-height: 50px;
}

.btn-chat-info {
  min-width: 100px;
}

.p-tag-cards {
  color: #163873;
  font-size: 14px;
  font-weight: 600;
}

.form-check-input[type="checkbox"] {
  border-radius: 0.25em;
  width: 20px;
  height: 20px;
}

.filter-left-h4-tag {
  color: #010404;
  font-size: 14px;
  font-weight: 700;
}

.fliter-tag-css {
  color: #010404;
  font-size: 24px;
}

.form-select-dropdown {
  min-width: 150px !important;
  height: 40px;
}

.select-dropdown-field {
  color: #010404 !important;
  font-size: 14px !important;
  font-weight: 500 !important;
}

.more-text {
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  padding-top: 10px;
  text-decoration: underline;
  color: #163873;
  cursor: pointer;
}

.btn-common-header {
  min-width: 130px;
  min-height: 40px;
}

.h4_title_booking {
  color: #000000 !important;
  font-size: 24px !important;
  font-weight: 700 !important;
}

.selected-option {
  color: #010404 !important;
  font-size: 14px !important;
  font-weight: 500 !important;
}

.img_dimension {
  width: 16px !important;
  height: 16px !important;
}

.img_bed_dimension {
  width: 20px !important;
  height: 16px !important;
}

.carousel-inner {
  border-radius: 20px 20px 0px 0px !important;
}

.p_tag_text {
  color: #5c677d;
}

.h2_tag_related {
  color: #010404 !important;
}

.card_checkin {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  gap: 15px;
}

.p-tag-check {
  color: #010404;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.check-tag-p {
  font-size: 14px;
  font-weight: 500;
  color: #5c677d;
  min-width: 70px;
  width: 100%;
}

.btn_sec_card {
  display: flex;
  gap: 15px;
}

.icons_technical {
  display: flex;
  gap: 10px;
}

.activeButton {
  color: #163873 !important;
}

.btn-common-icon {
  width: 40px;
  height: 40px;
  padding: 8px;
  border: none;
  border-radius: 10px;
  color: #808282;
}

.media {
  display: inline-flex;
  align-items: center;
}

.img-carousel-booking {
  min-height: 245px;
}

.css-nnid7-MuiSlider-valueLabel {
  display: none !important;
}

.dropdown-guests {
  min-width: 250px;
}

.css-1gv0vcd-MuiSlider-track {
  height: 6px !important;
}

.controlform-::-moz-placeholder {
  color: #808282 !important;
  opacity: 1;
}

.form-control:-ms-input-placeholder {
  color: #808282 !important;
}

.form-control::-webkit-input-placeholder {
  color: #808282 !important;
}

.form-color {
  color: #808282 !important;
}

.date_input_field {
  color: #010404;
  font-size: 20px;
  font-weight: 700;
  min-width: 48%;
}

/* Weekpicker range css */
.css-gtjfra-MuiDateRangePickerDay-root,
.css-1gbl7yn-MuiDateRangePickerDay-root,
.css-1i2r8k1-MuiDateRangePickerDay-root {
  background-color: #163873 !important;
}

button.MuiButtonBase-root.MuiPickersDay-root.MuiDateRangePickerDay-day.MuiDateRangePickerDay-notSelectedDate.MuiDateRangePickerDay-dayInsideRangeInterval.css-1gtnttf-MuiButtonBase-root-MuiPickersDay-root-MuiDateRangePickerDay-day {
  color: white !important;
}

.show_hidden {
  display: none !important;
}

.text_height_p {
  min-height: 36px;
}

/* add css  accoording figma*/
h4.h4-tab-booking {
  color: #000 !important;
}

.icon-chat {
  height: 20px !important;
  width: 20px !important;
}

.total-a label {
  color: var(--Black, #010404);
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.font-size-16 {
  font-size: 16px;
}

.customDatePicker .MuiFormControl-root {
  border: none;
}

.customDatePicker .MuiOutlinedInput-notchedOutline {
  border: none;
}

.range-div {
  max-width: 314px !important;
}

.img-destimation {
  width: 40px;
  height: 40px;
}

/* data */
.card_location_a {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  gap: 15px;
  border-bottom: 1px solid #e9ecef;
  height: 16px;
  width: 16px;
}

.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root {
  font-weight: 700 !important;
  font-size: 20px !important;
  line-height: 20px !important;

  color: #010404 !important;
}

.loc {
  width: 14px !important;
  height: 20px !important;
  display: block;
}

.star_min {
  height: 30px !important;
  width: 30px !important;
}

.span_color_text {
  color: #808282 !important;
}

.feature_image_icon {
  width: 50px !important;
  height: 50px !important;
}

.h4-available {
  color: #010404 !important;
}

.details-banner-img {
  max-width: 1180px;
  max-height: 660px;
}

.booking-banner-img {
  max-width: 1010px;
  max-height: 725px;
}

.span-number {
  font-size: 24px !important;
  font-weight: 500 !important;
}

p.p-feature-tag.mb-0_1 {
  font-size: 16px;
  color: #000 !important;
}

.css-grqin-MuiButtonBase-root-MuiPickersDay-root-MuiDateRangePickerDay-day.Mui-selected {
  background-color: #163873 !important;
}

.css-1a4q4r2-MuiButtonBase-root-MuiPickersDay-root-MuiDateRangePickerDay-day.Mui-selected {
  color: #fff;
  background-color: #163873 !important;
  font-weight: 500;
}

.vertical-line {
  height: 60px;
  width: 1px;
  background-color: #e9ecef;
}

.css-1jy569b-MuiFormLabel-root-MuiInputLabel-root {
  color: #5c677d !important;
  font-size: 20px !important;

  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal !important;
}

.css-net92d-MuiFormLabel-root-MuiInputLabel-root {
  color: #5c677d !important;
  font-weight: 500 !important;
  font-size: 20px !important;
}

.css-17kjmgj-MuiInputBase-root-MuiOutlinedInput-root {
  font-size: 20px !important;
  font-weight: 700 !important;
}

.customDatePicker {
  font-family: "Lato", sans-serif !important;
}

.dot_center {
  align-items: center !important;
}

.css-10wpov9-MuiTypography-root {
  font-weight: 600 !important;
  font-size: 1rem;
}

.css-e47596-MuiDateRangeCalendar-root > .div {
  display: none !important;
}

/* --------------------------------------------- */
/* Owner Pages CSS */
/* -------------------------------------------- */

/* Owner: Login page CSS */

.owner_login {
  width: 100%;
  height: 100vh !important;
  display: flex;
}

.owner_facility_login {
  width: 100%;
  display: flex;
}
.left-side {
  width: 50%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.customer_left {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
}

.welcome_text {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.welcome_text p {
  color: #fff;
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.welcome_text p span {
  font-weight: 700;
}

.customer_login_header .nav-link {
  color: var(--Black, #010404);
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.customer_login_header .navbar-nav {
  gap: 10px;
}

.left_content {
  padding: 50px 50px 50px 150px;
}

.choose_account label {
  color: var(--White, #fff);
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.choose_account p {
  color: var(--White, #fff);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  opacity: 0.75;
}

.name_account .form-label {
  color: var(--White, #fff);
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.name_account {
  gap: 10px;
}

.item_box p {
  color: var(--White, #fff);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.item_box {
  width: 100%;
  padding: 20px;
}

.item_box.active,
.item_box:hover {
  border-radius: 20px;
  border: 1px solid var(--White, #fff);
  background: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  width: 100%;
  padding: 20px;
}
.item_box:active {
  border-radius: 20px;
  border: 1px solid var(--White, #fff);
  background: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  width: 100%;
  padding: 20px;
}

.right-side {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.login_form {
  max-width: 500px;
  width: 100%;
  margin: auto;
  padding: 50px;
}

.login_form h3 {
  color: #163873;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: normal;
}

input#exampleFormControlInput1 {
  border: 1px solid #ddd !important;
}

.login_form .form-control {
  border-radius: 12px;
  border: 1px solid var(--Stroke, #e9ecef) !important;
  background: rgba(255, 255, 255, 0.01);
  min-height: 50px;
  padding-left: 50px;
  color: var(--Gray, #5c677d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.owner_input span {
  position: absolute;
  top: 10px;
  left: 10px;
}

.login_form .form-check label {
  color: var(--Gray-1, #808282);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-inline: 12px;
}

a.forgot_login {
  color: var(--Gray-1, #808282);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.owner_facility_login .btn-primary {
  display: inline-flex;
  height: 50px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #163873;
  border-color: #163873;
  color: var(--White, #fff);
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.owner_btn .btn-primary {
  display: inline-flex;
  height: 50px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #163873;
  border-color: #163873;
  color: var(--White, #fff);
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

p.register_login {
  position: relative;
  bottom: 20px;
  color: var(--Gray, #5c677d);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

p.register_login a {
  color: var(--Gray, #2176ff);
  font-weight: 700 !important;
}

.login_form .form-check label a {
  color: var(--Gray, #2176ff);
}

.user_text .form-check label {
  width: 100%;
}

.profile__tab .nav-pills a {
  display: flex;
  max-width: 200px;
  width: 100%;
  height: 40px;
  padding: 0px 10px;
  align-items: center;
  color: var(--Gray, #5c677d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.profile__tab .nav-pills .active {
  color: #163873;
  border-radius: 8px;
  background: rgba(22, 56, 115, 0.1);
}

.profile__content {
  max-width: 500px;
  width: 100%;
  padding: 0px 50px;
}

.profile__content .btn-primary {
  border-radius: 10px;
  background: #163873;
  border: 1px solid #163873;
  color: var(--White, #fff);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  min-height: 50px;
}

.pic_upload {
  margin: 20px 0px;
}

.profile__content .form-group .form-control {
  border-radius: 12px;
  border: 1px solid var(--Stroke, #e9ecef);
  background: #e9ecef;
  min-height: 50px;
}

.profile__content .form-group label {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.agent_login_option {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 15px;
}

p.tocken_value {
  color: #163873;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.agent_property_details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  flex-wrap: wrap;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 15px;
}

.details_item {
  max-width: 320px;
  width: 100%;
}

.details_item label {
  color: var(--grayscale-light-text-2, #acaebe);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.details_item p {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.regi_agent label {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.agent_register {
  display: flex;
  align-items: center;
  gap: 10px;
}

.olivia_name span {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.olivia_name p {
  color: var(--Gray, #5c677d);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.form-check-input {
  border: 1px solid var(--Stroke, #e9ecef) !important;
}

/* mui */
.css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root {
  padding: 9px 0px !important;
}

.custom-input .css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root {
  font-family: "Lato", sans-serif !important;
  font-weight: normal !important;
}

.selected {
  box-shadow: 10px 10px 10px #ccc;
  border-radius: 20px;
}

/* New css for testing */
.header_nav_link {
  color: #010404 !important;
  font-size: 20px !important;
  line-height: 24px !important;
  font-weight: 400 !important;
}
.img_color {
  color: #010404 !important;
  font-size: 14px !important;
}
.location_size {
  height: 16px !important;
  width: 16px !important;
}
.card_bed_size {
  width: 20px;
  height: 16px;
}
.agent_sidebar {
  font-weight: 500px !important;
  font-size: 14px !important;
  color: #808282 !important;
}
.num_apartment {
  color: #163873 !important;
  font-weight: 500px !important;
  font-size: 10px !important;
}
.h2_apartment {
  color: #808282 !important;
  font-size: 10px !important;
}
.user_h3 {
  color: #010404 !important;
  font-size: 16px !important;
  font-weight: 500px !important;
}
.sidebar_search_new {
  width: 270px;
  height: 40px;
}
.btn_chat_sidebar {
  height: 40px !important;
  width: 40px !important;
}
.text_time {
  color: #808282 !important;
  font-size: 8px !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

@media only screen and (min-width: 310px) and (max-width: 1024px) {
  .side_agent {
    margin: 30px 0px;
    border-radius: 20px;
    background: #fff;
    padding: 0px 10px;
    min-height: 100%;
    height: 0% !important;
  }
  .profile_content {
    border-radius: 14px;
    background: var(--White-color, #fff);
    padding: 50px 15px 0px;
    margin: 20px 0px;
    min-height: 100%;
    height: 100vh;
    height: 0%;
  }
}
/* //manage dimension of user panel home component */

@media only screen and (min-width: 310px) and (max-width: 525px) {
  .quality_img {
    width: 100% !important;
    height: 200px;
    border-radius: 30px;
  }
  .login_form {
    max-width: 500px;
    width: 100%;
    padding: 50px;
    margin: 28px auto 0;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner_search_box {
    display: block;
    margin-top: 160px;
  }
  .homeb {
    margin-left: 65px !important;
  }
}
.newlogin {
  margin-top: 150px;
}
`, "",{"version":3,"sources":["webpack://./src/components/userpenal/styles/styles.css"],"names":[],"mappings":"AAAA;EACE,qDAAqD;EACrD,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gEAAgE;EAChE,YAAY;EACZ,OAAO;EACP,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,MAAM;EACN,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,UAAU;AACZ;;AAEA;;EAEE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;;;;;;;;GAQG;;AAEH;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;;EAE5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;;EAEX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;EACrB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;;EAE3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;;EAE3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oDAAoD;EACpD,kCAA0B;UAA1B,0BAA0B;EAC1B,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;;EAEE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;EAC5B,kCAAkC;EAClC,8BAA8B;EAC9B,oBAAoB;EACpB,6BAA6B;EAC7B,6CAA6C;EAC7C,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,oDAAoD;EACpD,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,yCAAyC;EACzC,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;AAChC;;AAEA,yCAAyC;;AAEzC;yCACyC;;AAEzC;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;;AAEjB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,oCAAoC;EACpC,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,SAAS;AACT;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;EACrB,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;;EAE5B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;;EAE1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,kDAAkD;AAClD,oBAAoB;AACpB,iDAAiD;;AAEjD,0BAA0B;;AAE1B;EACE,WAAW;EACX,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,UAAU;EACV,YAAY;EACZ,yDAAiE;EACjE,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,oEAA+E;AACjF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,oCAAoC;EACpC,oCAAoC;EACpC,kCAA0B;UAA1B,0BAA0B;EAC1B,WAAW;EACX,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,oCAAoC;EACpC,kCAA0B;UAA1B,0BAA0B;EAC1B,WAAW;EACX,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,mDAAmD;EACnD,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;AACrD;;AAEA,QAAQ;AACR;EACE,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,oCAAoC;IACpC,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,UAAU;EACZ;AACF;AACA,oDAAoD;;AAEpD;EACE;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".banner-section {\n  /* background-image: url(../images/feature-bg.png); */\n  background-size: cover;\n  background-repeat: no-repeat;\n  min-height: 1080px;\n  background-color: #fff;\n  position: relative;\n}\n\n.banner-section .pattern {\n  position: absolute;\n  width: 50%;\n  /* background: url(../images/pattern-img.png) no-repeat right; */\n  height: 88px;\n  left: 0;\n  bottom: 0;\n}\n\n.banner-section .banner-img {\n  right: 0;\n  top: 0;\n  object-fit: cover;\n  height: 1080px;\n  width: 50%;\n}\n\n.banner-section .caption {\n  max-width: 100%;\n  color: #e7e1d8;\n  padding-left: 160px !important;\n  margin-top: 10rem;\n}\n\n.banner-section .caption h1 {\n  color: var(--Black, #010404);\n  line-height: normal;\n  letter-spacing: 3.2px;\n  text-transform: capitalize;\n}\n\n.banner-section .caption h1 span {\n  color: #163873;\n}\n\n.banner-section .caption h5 {\n  color: #808282;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 4px;\n  text-transform: uppercase;\n}\n\n.banner-section .caption p {\n  margin-bottom: 10px;\n  color: var(--Black, #010404);\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n  text-align: left;\n}\n\n.line {\n  border-radius: 4px;\n  background: var(--Primary, #163873);\n  width: 70px;\n  height: 3px;\n}\n\n.banner-section .caption .btn.btn-default {\n  margin-top: 31px;\n}\n\n.guest_serch_block {\n  border-radius: 20px;\n  padding: 30px;\n  gap: 30px;\n  width: 100%;\n  min-height: 190px;\n  position: absolute;\n  left: 50%;\n  bottom: 35%;\n  transform: translate(-50%, 100%);\n  z-index: 1;\n}\n\n.guest_serch_block .nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: var(--Primary, #549cac);\n  background-color: transparent;\n}\n\n.guest_serch_block .nav-link {\n  color: var(--Gray-1, #808282);\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  transition: 0.6s all ease-in-out;\n}\n\n.content_tab {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 50px;\n}\n\n/* .items_tab {\n    max-width: 250px;\n    width: 100%;\n    position: relative;\n    border-right: 1px solid #E9ECEF;\n}\n.items_tab:nth-child(4){\n\tborder: none;\n} */\n\n.items_tab h4 {\n  color: #231f20;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-bottom: 10px;\n}\n\n.items_tab p {\n  color: #010404;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.items_tab .form-control {\n  color: var(--Gray-1, #808282);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  border: none;\n  padding-left: 35px;\n}\n\n.items_tab i {\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  color: #5c677d;\n}\n\n.items_search a {\n  display: flex;\n  width: 60px;\n  height: 60px;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  border-radius: 12px;\n  background: var(--Primary, #163873);\n}\n\n.items_search a i {\n  color: #fff;\n  font-size: 34px;\n}\n\n/*Why US Section*/\n.why_us_wrap h2 {\n  text-align: center;\n  margin-bottom: 50px;\n  color: var(--Black, #010404);\n\n  font-size: 36px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 1.8px;\n  text-transform: capitalize;\n}\n\n.why_us_wrap h2 span {\n  color: #163873;\n}\n\n.card_us {\n  display: flex;\n  align-items: center;\n  gap: 25px;\n  border-radius: 14px;\n  border: 1px solid var(--Stroke, #e9ecef);\n  background: #fff;\n  padding: 20px;\n  min-height: 100%;\n  overflow: auto;\n  flex-direction: row !important;\n}\n\n.icon_sec {\n  min-width: 50px;\n  height: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.icon_sec.card_one {\n  border-radius: 12px;\n}\n\n.icon_sec.card_two {\n  border-radius: 12px;\n  background: rgba(157, 78, 221, 0.1);\n}\n\n.icon_sec.card_three {\n  border-radius: 12px;\n  background: rgba(0, 124, 255, 0.1);\n}\n\n.icon_sec.card_four {\n  border-radius: 12px;\n  background: rgba(0, 128, 0, 0.1);\n}\n\n.card.card_us p {\n  color: #000000;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-transform: capitalize;\n}\n\n/*Quality Listings Section*/\n.quality_content h2 {\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  text-transform: capitalize;\n  margin-bottom: 20px;\n}\n\n.btn_sec {\n  display: flex;\n  gap: 15px;\n}\n\n.btn_sec .btn {\n  width: 180px;\n  height: 50px;\n}\n\n.btn_sec .btn:hover {\n  border: none;\n  background-color: #000;\n  color: #fff;\n}\n\n.quality_pic {\n  margin-bottom: 50px;\n  position: relative;\n  transition: 0.6s all ease-in-out;\n}\n\n.quality_pic img {\n  width: 100%;\n}\n\n.quality_caption {\n  position: absolute;\n  bottom: 0px;\n  left: 15px;\n}\n\n.quality_caption h5 {\n  color: var(--White, #fff);\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.quality_caption p {\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n/*Home for you*/\n.home_heading p {\n  color: var(--Gray, #5c677d);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-transform: capitalize;\n  text-align: center;\n  margin-top: 10px;\n}\n\n.image_body .slick-dots {\n  bottom: 20px;\n}\n\n.image_body .slick-dots li button:before {\n  font-size: 10px;\n  line-height: 20px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  content: \"•\";\n  text-align: center;\n  opacity: 0.5;\n  color: #eeeeee;\n}\n\n.image_body {\n  margin-bottom: 0 !important;\n}\n\n.image_body .slick-dots li.slick-active button:before {\n  color: #fff;\n  opacity: 1;\n}\n\n.home_card {\n  border-radius: 20px !important;\n  box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.03);\n}\n\n.badge_btn {\n  width: 61px;\n  height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 30px;\n  background: #1638731a;\n}\n\n.badge_btn p {\n  color: var(--Primary, #163873);\n  text-align: center;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-bottom: 0;\n}\n\n.card_heading_block {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.card_heading_block h2 {\n  color: #000;\n  font-size: 20px !important;\n  font-style: normal;\n  font-weight: 500 !important;\n  line-height: normal;\n  text-transform: capitalize;\n}\n\n.card_heading_block span {\n  color: #000;\n\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.card_location {\n  display: flex;\n  justify-content: flex-start;\n  align-items: baseline;\n  gap: 15px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.card_desc {\n  padding-top: 10px;\n}\n\n.card_desc p {\n  color: var(--Gray, #5c677d);\n  text-align: justify;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.card_bottom_icon {\n  display: flex;\n  gap: 10px;\n}\n\n.card_btn {\n  width: 100%;\n}\n\n.card_btn .btn_primary {\n  width: 100%;\n  border-radius: 0px 0px 20px 20px;\n  height: 50px;\n}\n\n.image_header {\n  position: absolute;\n  top: 0px;\n  left: 0;\n  width: 100%;\n  padding: 10px;\n  align-items: center;\n}\n\n.image_header_booking {\n  position: absolute;\n  top: 20px;\n  left: 0;\n  width: 100%;\n  padding: 10px;\n  align-items: center;\n}\n\n.quantity_box {\n  width: 100%;\n  max-width: 106px;\n  border-radius: 6px;\n  background: #fff;\n  padding: 5px;\n  height: 30px;\n}\n\n.box-quant {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.btn_view {\n  max-width: 180px;\n  width: 100%;\n  height: 50px;\n}\n\n/* 5.Contact Us*/\n.contact_content {\n  max-width: 1000px;\n  margin: auto;\n}\n\n.or_seprate {\n  max-width: 350px;\n  width: 100%;\n  height: 1px;\n  background: #5c677d1f;\n  margin: auto;\n  text-align: center;\n  position: relative;\n}\n\n.or_seprate span {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, -55%);\n  background: #fff;\n  padding: 5px;\n  color: var(--Gray, #5c677d);\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.contact_block {\n  width: 100%;\n  align-items: center;\n}\n\n.contact_desc h4 {\n  color: var(--Gray, #5c677d);\n\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  text-transform: capitalize;\n}\n\n.contact_desc p {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.2px;\n}\n\n.contact_desc p a {\n  color: #163873;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.2px;\n  text-decoration-line: underline;\n  white-space: nowrap;\n}\n\n.form-field-input {\n  height: 50px;\n  color: #808282 !important;\n}\n\n.h2-tag-text {\n  font-size: 36px;\n  font-weight: 700;\n  line-height: 43px;\n  letter-spacing: 0em;\n  color: #010404;\n}\n\n/*Banner properties Page*/\n.inner_banner {\n  width: 100%;\n  margin-top: 124px;\n}\n\n.inner_banner img {\n  width: 100%;\n}\n\n.banner_search_box {\n  border-radius: 20px;\n  background: #fff;\n  box-shadow: 0px 0px 40px 0px rgba(84, 156, 172, 0.2);\n  backdrop-filter: blur(5px);\n  padding: 30px;\n  width: 100%;\n  max-width: 1470px;\n  min-height: 190px;\n  position: relative;\n  bottom: 95px;\n  z-index: 1;\n}\n\n.banner_search_box .nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: var(--Primary, #163873);\n  background-color: transparent;\n}\n\n.banner_search_box .nav-link {\n  color: var(--Gray-1, #808282);\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  transition: 0.6s all ease-in-out;\n}\n\n/*Banner Search box*/\n.properties_search_sec,\n.tab_top_btn {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.btn_clear {\n  display: flex !important;\n  height: 40px !important;\n  padding: 0px 12px !important;\n  justify-content: center !important;\n  align-items: center !important;\n  gap: 10px !important;\n  border-radius: 8px !important;\n  background: rgba(253, 13, 13, 0.1) !important;\n  color: #fd0d0d !important;\n  text-align: center !important;\n  font-size: 16px !important;\n  font-style: normal !important;\n  font-weight: 500 !important;\n  line-height: normal !important;\n}\n\n.banner_search_box .content_tab {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 50px;\n}\n\n.tab_range h4 {\n  color: var(--Dark, #231f20);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.value-label {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: var(--Dark, #231f20);\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.values {\n  padding: 20px 0;\n  display: flex;\n  color: var(--Dark, #231f20);\n  text-align: center;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.max-value {\n  margin-left: auto;\n}\n\n.range-slider {\n  margin-top: 10px;\n  position: relative;\n}\n\n.range-slider-track {\n  width: 100%;\n  height: 10px;\n  position: relative;\n  overflow: hidden;\n  border-radius: 10px;\n  background: var(--Stroke, #e9ecef);\n}\n\n.slider-track-filled {\n  width: 100%;\n  height: 10px;\n  position: absolute;\n  transform-origin: 0 0;\n  border-radius: 10px;\n  background: var(--Primary, #163873);\n}\n\n.min-thumb,\n.max-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: white;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 4;\n  user-select: none;\n  filter: drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.18));\n}\n\n.min-thumb {\n  left: 0;\n}\n\n.max-thumb {\n  right: 0;\n}\n\n/*Filter Section*/\n.filter_block {\n  border-right: 1px solid #e9ecef;\n}\n\n.filter_side {\n  width: 100%;\n  min-width: 314px !important;\n}\n\n.filter_side_content h5 {\n  color: var(--Black, #010404);\n  text-align: justify;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-bottom: 20px;\n}\n\n.side_items label {\n  color: var(--Black, #000);\n  text-align: justify;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.side_items .form-check-input:checked {\n  background-color: #163873;\n  border-color: #163873;\n}\n\n.side_items {\n  margin-bottom: 15px;\n}\n\n.filter_side_content .input-group {\n  margin-bottom: 15px;\n}\n\n/* lg-8 */\n.filter_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.filter_header_btns {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.sort_drop {\n  display: flex;\n  align-items: center;\n  min-width: 200px;\n  width: 100%;\n  gap: 10px;\n}\n\n.filter_header h5 {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n}\n\n.sort_drop label {\n  color: var(--Black, #010404);\n  min-width: 50px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.filter_content .home_card {\n  flex-direction: row;\n  padding: 10px;\n  align-items: center;\n}\n\n.filter_content .image_body {\n  max-width: 300px;\n  width: 100%;\n  height: 100%;\n}\n\n.filter_content .card-body {\n  width: 100%;\n}\n\n.filter_content .card_btn {\n  width: auto;\n}\n\n.filter_content .btn_primary {\n  border-radius: 10px;\n}\n\n.filter_content .pic_item img {\n  border-radius: 20px !important;\n}\n\n.filter_pagination {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n\n.filter_pagination .page-link {\n  color: var(--Gray, #5c677d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  border: none;\n}\n\n.filter_pagination .active > .page-link,\n.page-link.active {\n  border-radius: 10px;\n  background: var(--Primary, #163873);\n  color: var(--White, #fff);\n}\n\n.filter_content .slick-next:before,\n.slick-prev:before {\n  display: none;\n}\n\n/* (Page 3:) 1: Detail Banner Page*/\n.detail_banner {\n  width: 100%;\n  margin-top: 124px;\n}\n\n.bg-detail {\n  width: 100%;\n  height: 100%;\n}\n\n.detail_banner img {\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n}\n\n.side_detail_pic {\n  width: 100%;\n  min-height: 150px;\n}\n\n.side_detail_pic img {\n  border-radius: 20px;\n  width: 100%;\n  object-fit: cover;\n  min-height: 150px;\n}\n\n.star {\n  width: auto !important;\n}\n\n/* (Page 3:)  Booking Section*/\n.booking_larg .badge_btn {\n  width: 85px;\n  height: 35px;\n  border-radius: 40px;\n  margin-bottom: 10px;\n}\n\n.booking_larg .badge_btn p {\n  color: var(--Primary, #163873);\n  font-size: 14px;\n}\n\n.booking_larg .card_heading_block h2 {\n  color: #000;\n  font-size: 32px !important;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-transform: capitalize;\n}\n\n.booking_larg .card_location {\n  margin-top: 10px;\n}\n\n.booking_larg .card_location p {\n  color: var(--Primary, #163873);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.booking_larg .card_desc {\n  margin-top: 10px;\n}\n\n.booking_larg .card_desc h4 {\n  color: var(--Black, #010404);\n  text-align: justify;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-bottom: 15px;\n}\n\n.booking_larg .card_desc p {\n  color: var(--Gray, #5c677d);\n}\n\n.feature_icon_sec {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.features_bedroom {\n  border-bottom: 1px solid #e9ecef;\n}\n\n.feature_icon {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n}\n\n.available_block {\n  display: flex;\n  align-items: end;\n  gap: 10px;\n}\n\n.availability_calender img {\n  width: 100%;\n}\n\n.map_tour {\n  border-top: 1px solid #e9ecef;\n}\n\n.map_btn_sec .btn_primary {\n  width: 100%;\n}\n\n/* booking card */\n.booking_card {\n  border-radius: 20px !important;\n  background: #fff;\n  box-shadow: 0px 0px 40px 0px rgba(84, 156, 172, 0.2);\n  border: #ffffff !important;\n  padding: 30px;\n}\n\n.booking_dollar p {\n  color: #000;\n  font-size: 36px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.booking_dollar p span {\n  color: var(--Gray, #5c677d);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.booking_card_content .input_group {\n  width: 48%;\n}\n\n.booking_card_content .input_group .form-select {\n  border: none;\n  color: var(--Black, #010404);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n  padding: 0px;\n  background-image: none;\n}\n\n.agent_code p {\n  color: var(--Gray, #5c677d);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.agent_code p span {\n  color: var(--Gray, #5c677d);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.agent_code h3 {\n  color: var(--Primary, #163873);\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n}\n\n.input_group label {\n  color: var(--Gray, #5c677d);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.input_group h6 {\n  color: var(--Black, #010404);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n  margin-top: 10px;\n}\n\n.border-_bottom {\n  border-bottom: 1px solid #e9ecef;\n}\n\n.total label {\n  color: var(--Black, #010404);\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.reserve .btn_primary {\n  width: 100%;\n  height: 50px;\n  font-size: 20px !important;\n}\n\n/* (Page 4:) My Booking Section*/\n.btn_chat {\n  display: flex;\n  width: 200px;\n  height: 50px;\n  padding: 2px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  border: 1px solid var(--Primary, #163873);\n  background: var(--White, #fff);\n  color: var(--Primary, #163873);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.border-_top {\n  border-top: 1px solid #e9ecef;\n}\n\n.listing_booking {\n  margin-top: 125px;\n}\n\n.btn_pending {\n  width: 150px;\n  height: 50px;\n  border-radius: 10px;\n  background: #ffd9c4;\n  color: #ff8038;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.btn_accepted {\n  width: 150px;\n  height: 50px;\n  border-radius: 10px;\n  background: rgba(56, 176, 0, 0.3);\n  color: #38b000;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.online_condiiton {\n  display: flex;\n  align-items: center;\n  gap: 50px;\n  justify-content: space-between;\n}\n\n/*--------------------------------------*/\n\n/* (Page 5:) Chat Page\n/*--------------------------------------*/\n\n.chat_sec {\n  margin-top: 124px;\n}\n\n.side_agent {\n  margin: 30px 0px;\n  border-radius: 20px;\n  background: #fff;\n  padding: 0px 10px;\n  min-height: 100%;\n  height: 100vh !important;\n}\n\n.user_side_agent {\n  min-height: 94% !important;\n}\n.agent_search {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n  gap: 15px;\n  height: 50px;\n  border-bottom: 1px solid #e5e6e7;\n  padding: 40px 0px;\n}\n\n.btn_agent {\n  background: #eef5f7;\n  padding: 10px 12px;\n}\n\n.agent_category .btn_primary {\n  height: 35px;\n  width: 100%;\n  color: var(--Gray-1, #808282);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  background-color: transparent;\n  justify-content: left;\n  padding: 10px 5px;\n}\n\n.agent_category {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.agent_category .dropdown {\n  width: 100%;\n}\n\n.agent_category .dropdown-menu.show {\n  display: block;\n  width: 100%;\n}\n\n.agent_item_list {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 10px;\n  cursor: pointer;\n}\n\n.active_agent {\n  border-radius: 12px;\n  background: rgba(129, 217, 247, 0.25);\n}\n\n.agent_name {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.agent_name h5 {\n  color: var(--Black, #010404);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.agent_name p {\n  color: var(--Gray-1, #808282);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.agent_mode p {\n  margin: 0;\n  color: var(--Gray-1, #808282);\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.agent_chatbot {\n  margin: 30px 0px;\n}\n\n.chat_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  border-radius: 20px;\n  background: var(--grayscale-white, #fff);\n  padding: 20px;\n  gap: 10px;\n}\n\n.agent_logo {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.chat_agent h5 {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.chat_agent p {\n  color: var(--Gray-1, #808282);\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: 0;\n}\n\n.chat_bedroom h3 {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.chat_bedroom p {\n  color: var(--Gray-1, #808282);\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-top: 5px;\n}\n\n.chat_bedroom p a {\n  color: #163873;\n}\n\n/* ------------ */\n\n.chat-online {\n  color: #34ce57;\n}\n\n.chat-offline {\n  color: #e4606d;\n}\n\n.chat-messages {\n  display: flex;\n  flex-direction: column;\n}\n\n.chat-message-right {\n  display: block;\n  margin-left: auto;\n}\n\n.chat-message-left {\n  margin-right: auto;\n  display: flex;\n  flex-shrink: 0;\n}\n\n.chat-messages .py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.chat-messages .px-4 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.chat-messages .flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.chat-messages .border-top {\n  border-top: 1px solid #dee2e6 !important;\n}\n\n.Amelia_text h3 {\n  color: var(--Black, #010404);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.Amelia_text p {\n  color: var(--Black, #010404);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  border-radius: 0px 12px 12px 12px;\n  background: var(--White-color, #fff);\n  padding: 10px;\n  margin: 0;\n}\n\n.cht_time .text-muted {\n  color: #808282 !important;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-bottom: 15px;\n}\n\n.you_right {\n  display: flex;\n  gap: 10px;\n  justify-content: end;\n}\n\n.right_text .text-muted {\n  color: var(--Gray-1, #808282) !important;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.you_right h3 {\n  color: var(--Black, #010404);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.right_msg {\n  display: flex;\n  width: 100%;\n  text-align: justify;\n  color: #fff;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  border-radius: 12px 0px 12px 12px;\n  background: #163873;\n  margin-top: 5px;\n}\n\n.chat_footer img {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n\n.chat_footer .form-control {\n  border: none;\n  border-radius: 10px;\n  background: var(--White-color, #fff);\n  padding: 15px;\n  color: #808282 !important;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.chat_profile {\n  margin: 30px 0px;\n  height: 100%;\n}\n\n.profile_header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 20px;\n  border: 1px solid var(--Stroke, #e9ecef);\n  background: #fff;\n  padding: 15px;\n}\n\n.booked_date label {\n  color: var(--Gray, #5c677d);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.booked_date h3 {\n  color: var(--Black, #010404);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n}\n\n.profile_content {\n  border-radius: 14px;\n  background: var(--White-color, #fff);\n  padding: 50px 15px 0px;\n  margin: 20px 0px;\n  min-height: 100%;\n  height: 100vh;\n}\n\n.user_profile_content {\n  min-height: 83% !important;\n}\n.dp_pic {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n}\n\n.dp_pic h3 {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.dp_pic p {\n  color: var(--Gray-1, #808282);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin: 0;\n}\n\nbutton.nav-link.active {\n  color: #163873 !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 19px !important;\n  letter-spacing: 0px !important;\n}\n\n.form-check-input:checked {\n  background-color: #163873 !important;\n  border-color: #163873 !important;\n}\n\n.classUnique {\n  font-weight: 700 !important;\n  padding-right: 5px;\n  padding-left: 5px;\n}\n\n.quality_img {\n  width: 200px !important;\n  height: 200px;\n  border-radius: 30px;\n}\n\n/* Seema-code */\n.h4-feature {\n  font-size: 24px;\n  font-weight: 700;\n  text-align: justify;\n  color: #010404;\n}\n\n.small_feature {\n  font-size: 14px;\n  font-weight: 600;\n  color: #010404;\n}\n\n.btn-booking-tour {\n  height: 50px;\n  font-size: 20px !important;\n}\n\n.send {\n  font-size: 18px;\n  font-weight: 700;\n  color: #010404;\n}\n\n.contact-feature {\n  font-size: 36px;\n  font-weight: 700;\n}\n\n.homeforyou {\n  font-size: 36px !important;\n  font-weight: 700 !important;\n  color: #010404;\n}\n\n.bannertext {\n  font-weight: 900 !important;\n  font-size: 64px;\n}\n\n/* Bhupendra new css */\n.img-carousel {\n  max-width: 300px;\n  min-height: 210px;\n}\n\n.span-tag-card {\n  font-size: 14px;\n  font-weight: 400;\n  color: #010404;\n}\n\n.btn-more-info {\n  min-width: 150px !important;\n  min-height: 50px;\n}\n\n.btn-chat-info {\n  min-width: 100px;\n}\n\n.p-tag-cards {\n  color: #163873;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.form-check-input[type=\"checkbox\"] {\n  border-radius: 0.25em;\n  width: 20px;\n  height: 20px;\n}\n\n.filter-left-h4-tag {\n  color: #010404;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.fliter-tag-css {\n  color: #010404;\n  font-size: 24px;\n}\n\n.form-select-dropdown {\n  min-width: 150px !important;\n  height: 40px;\n}\n\n.select-dropdown-field {\n  color: #010404 !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n}\n\n.more-text {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: 0em;\n  padding-top: 10px;\n  text-decoration: underline;\n  color: #163873;\n  cursor: pointer;\n}\n\n.btn-common-header {\n  min-width: 130px;\n  min-height: 40px;\n}\n\n.h4_title_booking {\n  color: #000000 !important;\n  font-size: 24px !important;\n  font-weight: 700 !important;\n}\n\n.selected-option {\n  color: #010404 !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n}\n\n.img_dimension {\n  width: 16px !important;\n  height: 16px !important;\n}\n\n.img_bed_dimension {\n  width: 20px !important;\n  height: 16px !important;\n}\n\n.carousel-inner {\n  border-radius: 20px 20px 0px 0px !important;\n}\n\n.p_tag_text {\n  color: #5c677d;\n}\n\n.h2_tag_related {\n  color: #010404 !important;\n}\n\n.card_checkin {\n  display: flex;\n  justify-content: flex-start;\n  align-items: baseline;\n  gap: 15px;\n}\n\n.p-tag-check {\n  color: #010404;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.check-tag-p {\n  font-size: 14px;\n  font-weight: 500;\n  color: #5c677d;\n  min-width: 70px;\n  width: 100%;\n}\n\n.btn_sec_card {\n  display: flex;\n  gap: 15px;\n}\n\n.icons_technical {\n  display: flex;\n  gap: 10px;\n}\n\n.activeButton {\n  color: #163873 !important;\n}\n\n.btn-common-icon {\n  width: 40px;\n  height: 40px;\n  padding: 8px;\n  border: none;\n  border-radius: 10px;\n  color: #808282;\n}\n\n.media {\n  display: inline-flex;\n  align-items: center;\n}\n\n.img-carousel-booking {\n  min-height: 245px;\n}\n\n.css-nnid7-MuiSlider-valueLabel {\n  display: none !important;\n}\n\n.dropdown-guests {\n  min-width: 250px;\n}\n\n.css-1gv0vcd-MuiSlider-track {\n  height: 6px !important;\n}\n\n.controlform-::-moz-placeholder {\n  color: #808282 !important;\n  opacity: 1;\n}\n\n.form-control:-ms-input-placeholder {\n  color: #808282 !important;\n}\n\n.form-control::-webkit-input-placeholder {\n  color: #808282 !important;\n}\n\n.form-color {\n  color: #808282 !important;\n}\n\n.date_input_field {\n  color: #010404;\n  font-size: 20px;\n  font-weight: 700;\n  min-width: 48%;\n}\n\n/* Weekpicker range css */\n.css-gtjfra-MuiDateRangePickerDay-root,\n.css-1gbl7yn-MuiDateRangePickerDay-root,\n.css-1i2r8k1-MuiDateRangePickerDay-root {\n  background-color: #163873 !important;\n}\n\nbutton.MuiButtonBase-root.MuiPickersDay-root.MuiDateRangePickerDay-day.MuiDateRangePickerDay-notSelectedDate.MuiDateRangePickerDay-dayInsideRangeInterval.css-1gtnttf-MuiButtonBase-root-MuiPickersDay-root-MuiDateRangePickerDay-day {\n  color: white !important;\n}\n\n.show_hidden {\n  display: none !important;\n}\n\n.text_height_p {\n  min-height: 36px;\n}\n\n/* add css  accoording figma*/\nh4.h4-tab-booking {\n  color: #000 !important;\n}\n\n.icon-chat {\n  height: 20px !important;\n  width: 20px !important;\n}\n\n.total-a label {\n  color: var(--Black, #010404);\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.font-size-16 {\n  font-size: 16px;\n}\n\n.customDatePicker .MuiFormControl-root {\n  border: none;\n}\n\n.customDatePicker .MuiOutlinedInput-notchedOutline {\n  border: none;\n}\n\n.range-div {\n  max-width: 314px !important;\n}\n\n.img-destimation {\n  width: 40px;\n  height: 40px;\n}\n\n/* data */\n.card_location_a {\n  display: flex;\n  justify-content: flex-start;\n  align-items: baseline;\n  gap: 15px;\n  border-bottom: 1px solid #e9ecef;\n  height: 16px;\n  width: 16px;\n}\n\n.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root {\n  font-weight: 700 !important;\n  font-size: 20px !important;\n  line-height: 20px !important;\n\n  color: #010404 !important;\n}\n\n.loc {\n  width: 14px !important;\n  height: 20px !important;\n  display: block;\n}\n\n.star_min {\n  height: 30px !important;\n  width: 30px !important;\n}\n\n.span_color_text {\n  color: #808282 !important;\n}\n\n.feature_image_icon {\n  width: 50px !important;\n  height: 50px !important;\n}\n\n.h4-available {\n  color: #010404 !important;\n}\n\n.details-banner-img {\n  max-width: 1180px;\n  max-height: 660px;\n}\n\n.booking-banner-img {\n  max-width: 1010px;\n  max-height: 725px;\n}\n\n.span-number {\n  font-size: 24px !important;\n  font-weight: 500 !important;\n}\n\np.p-feature-tag.mb-0_1 {\n  font-size: 16px;\n  color: #000 !important;\n}\n\n.css-grqin-MuiButtonBase-root-MuiPickersDay-root-MuiDateRangePickerDay-day.Mui-selected {\n  background-color: #163873 !important;\n}\n\n.css-1a4q4r2-MuiButtonBase-root-MuiPickersDay-root-MuiDateRangePickerDay-day.Mui-selected {\n  color: #fff;\n  background-color: #163873 !important;\n  font-weight: 500;\n}\n\n.vertical-line {\n  height: 60px;\n  width: 1px;\n  background-color: #e9ecef;\n}\n\n.css-1jy569b-MuiFormLabel-root-MuiInputLabel-root {\n  color: #5c677d !important;\n  font-size: 20px !important;\n\n  font-style: normal !important;\n  font-weight: 500 !important;\n  line-height: normal !important;\n}\n\n.css-net92d-MuiFormLabel-root-MuiInputLabel-root {\n  color: #5c677d !important;\n  font-weight: 500 !important;\n  font-size: 20px !important;\n}\n\n.css-17kjmgj-MuiInputBase-root-MuiOutlinedInput-root {\n  font-size: 20px !important;\n  font-weight: 700 !important;\n}\n\n.customDatePicker {\n  font-family: \"Lato\", sans-serif !important;\n}\n\n.dot_center {\n  align-items: center !important;\n}\n\n.css-10wpov9-MuiTypography-root {\n  font-weight: 600 !important;\n  font-size: 1rem;\n}\n\n.css-e47596-MuiDateRangeCalendar-root > .div {\n  display: none !important;\n}\n\n/* --------------------------------------------- */\n/* Owner Pages CSS */\n/* -------------------------------------------- */\n\n/* Owner: Login page CSS */\n\n.owner_login {\n  width: 100%;\n  height: 100vh !important;\n  display: flex;\n}\n\n.owner_facility_login {\n  width: 100%;\n  display: flex;\n}\n.left-side {\n  width: 50%;\n  height: 100%;\n  background-image: url(\"../../../images/login/bg-owner-login.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.customer_left {\n  background-image: url(\"../../../images/login/customer-login-bg.png\") !important;\n}\n\n.welcome_text {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.welcome_text p {\n  color: #fff;\n  font-size: 40px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.welcome_text p span {\n  font-weight: 700;\n}\n\n.customer_login_header .nav-link {\n  color: var(--Black, #010404);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.customer_login_header .navbar-nav {\n  gap: 10px;\n}\n\n.left_content {\n  padding: 50px 50px 50px 150px;\n}\n\n.choose_account label {\n  color: var(--White, #fff);\n  text-align: center;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.choose_account p {\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n  opacity: 0.75;\n}\n\n.name_account .form-label {\n  color: var(--White, #fff);\n  text-align: center;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.name_account {\n  gap: 10px;\n}\n\n.item_box p {\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.item_box {\n  width: 100%;\n  padding: 20px;\n}\n\n.item_box.active,\n.item_box:hover {\n  border-radius: 20px;\n  border: 1px solid var(--White, #fff);\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(5px);\n  width: 100%;\n  padding: 20px;\n}\n.item_box:active {\n  border-radius: 20px;\n  border: 1px solid var(--White, #fff);\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(5px);\n  width: 100%;\n  padding: 20px;\n}\n\n.right-side {\n  width: 50%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.login_form {\n  max-width: 500px;\n  width: 100%;\n  margin: auto;\n  padding: 50px;\n}\n\n.login_form h3 {\n  color: #163873;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: normal;\n}\n\ninput#exampleFormControlInput1 {\n  border: 1px solid #ddd !important;\n}\n\n.login_form .form-control {\n  border-radius: 12px;\n  border: 1px solid var(--Stroke, #e9ecef) !important;\n  background: rgba(255, 255, 255, 0.01);\n  min-height: 50px;\n  padding-left: 50px;\n  color: var(--Gray, #5c677d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.owner_input span {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n}\n\n.login_form .form-check label {\n  color: var(--Gray-1, #808282);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-inline: 12px;\n}\n\na.forgot_login {\n  color: var(--Gray-1, #808282);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.owner_facility_login .btn-primary {\n  display: inline-flex;\n  height: 50px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: #163873;\n  border-color: #163873;\n  color: var(--White, #fff);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.owner_btn .btn-primary {\n  display: inline-flex;\n  height: 50px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: #163873;\n  border-color: #163873;\n  color: var(--White, #fff);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\np.register_login {\n  position: relative;\n  bottom: 20px;\n  color: var(--Gray, #5c677d);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\np.register_login a {\n  color: var(--Gray, #2176ff);\n  font-weight: 700 !important;\n}\n\n.login_form .form-check label a {\n  color: var(--Gray, #2176ff);\n}\n\n.user_text .form-check label {\n  width: 100%;\n}\n\n.profile__tab .nav-pills a {\n  display: flex;\n  max-width: 200px;\n  width: 100%;\n  height: 40px;\n  padding: 0px 10px;\n  align-items: center;\n  color: var(--Gray, #5c677d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.profile__tab .nav-pills .active {\n  color: #163873;\n  border-radius: 8px;\n  background: rgba(22, 56, 115, 0.1);\n}\n\n.profile__content {\n  max-width: 500px;\n  width: 100%;\n  padding: 0px 50px;\n}\n\n.profile__content .btn-primary {\n  border-radius: 10px;\n  background: #163873;\n  border: 1px solid #163873;\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  min-height: 50px;\n}\n\n.pic_upload {\n  margin: 20px 0px;\n}\n\n.profile__content .form-group .form-control {\n  border-radius: 12px;\n  border: 1px solid var(--Stroke, #e9ecef);\n  background: #e9ecef;\n  min-height: 50px;\n}\n\n.profile__content .form-group label {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.agent_login_option {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  margin-top: 15px;\n}\n\np.tocken_value {\n  color: #163873;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.agent_property_details {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n  border-bottom: 1px solid #e9ecef;\n  padding-bottom: 15px;\n}\n\n.details_item {\n  max-width: 320px;\n  width: 100%;\n}\n\n.details_item label {\n  color: var(--grayscale-light-text-2, #acaebe);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.details_item p {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.regi_agent label {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.agent_register {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.olivia_name span {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.olivia_name p {\n  color: var(--Gray, #5c677d);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.form-check-input {\n  border: 1px solid var(--Stroke, #e9ecef) !important;\n}\n\n/* mui */\n.css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root {\n  padding: 9px 0px !important;\n}\n\n.custom-input .css-8j6b76-MuiInputBase-root-MuiOutlinedInput-root {\n  font-family: \"Lato\", sans-serif !important;\n  font-weight: normal !important;\n}\n\n.selected {\n  box-shadow: 10px 10px 10px #ccc;\n  border-radius: 20px;\n}\n\n/* New css for testing */\n.header_nav_link {\n  color: #010404 !important;\n  font-size: 20px !important;\n  line-height: 24px !important;\n  font-weight: 400 !important;\n}\n.img_color {\n  color: #010404 !important;\n  font-size: 14px !important;\n}\n.location_size {\n  height: 16px !important;\n  width: 16px !important;\n}\n.card_bed_size {\n  width: 20px;\n  height: 16px;\n}\n.agent_sidebar {\n  font-weight: 500px !important;\n  font-size: 14px !important;\n  color: #808282 !important;\n}\n.num_apartment {\n  color: #163873 !important;\n  font-weight: 500px !important;\n  font-size: 10px !important;\n}\n.h2_apartment {\n  color: #808282 !important;\n  font-size: 10px !important;\n}\n.user_h3 {\n  color: #010404 !important;\n  font-size: 16px !important;\n  font-weight: 500px !important;\n}\n.sidebar_search_new {\n  width: 270px;\n  height: 40px;\n}\n.btn_chat_sidebar {\n  height: 40px !important;\n  width: 40px !important;\n}\n.text_time {\n  color: #808282 !important;\n  font-size: 8px !important;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n@media only screen and (min-width: 310px) and (max-width: 1024px) {\n  .side_agent {\n    margin: 30px 0px;\n    border-radius: 20px;\n    background: #fff;\n    padding: 0px 10px;\n    min-height: 100%;\n    height: 0% !important;\n  }\n  .profile_content {\n    border-radius: 14px;\n    background: var(--White-color, #fff);\n    padding: 50px 15px 0px;\n    margin: 20px 0px;\n    min-height: 100%;\n    height: 100vh;\n    height: 0%;\n  }\n}\n/* //manage dimension of user panel home component */\n\n@media only screen and (min-width: 310px) and (max-width: 525px) {\n  .quality_img {\n    width: 100% !important;\n    height: 200px;\n    border-radius: 30px;\n  }\n  .login_form {\n    max-width: 500px;\n    width: 100%;\n    padding: 50px;\n    margin: 28px auto 0;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .banner_search_box {\n    display: block;\n    margin-top: 160px;\n  }\n  .homeb {\n    margin-left: 65px !important;\n  }\n}\n.newlogin {\n  margin-top: 150px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
